import { lazyRegister } from "@/Core/lazyRegister";
import IScope = angular.IScope;
import IAugmentedJQuery = angular.IAugmentedJQuery;
import IAttributes = angular.IAttributes;
import IDirective = angular.IDirective;

class ScrollToTopDirective implements IDirective {
    restrict = 'A';

    // Hàm link cần dùng arrow function để không bị mất ngữ cảnh `this` nếu cần mở rộng sau này
    link = (scope: IScope, element: IAugmentedJQuery, attrs: IAttributes): void => {
        const parentSelector: string = attrs.scrollToTop || 'main';
        const scrollContainer: HTMLElement | null = document.querySelector(parentSelector);

        if (!scrollContainer) return;

        const onScroll = (): void => {
            const halfHeight: number = scrollContainer.clientHeight / 2;
            if (scrollContainer.scrollTop > halfHeight) {
                element.removeClass('hidden');
            } else {
                element.addClass('hidden');
            }
        };

        // Đăng ký các sự kiện
        scrollContainer.addEventListener('scroll', onScroll);

        element.on('click', (): void => {
            scrollContainer.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });

        // Dọn dẹp bộ nhớ khi hủy directive
        scope.$on('$destroy', (): void => {
            scrollContainer.removeEventListener('scroll', onScroll);
            element.off('click');
        });
    }

    // Hàm factory để khởi tạo directive cho AngularJS
    static factory(): (...args: any[]) => IDirective {
        return () => new ScrollToTopDirective();
    }
}

// Đăng ký vào lazyRegister sử dụng hàm factory
lazyRegister.directive('scrollToTop', ScrollToTopDirective.factory());
